import { Controller } from '@hotwired/stimulus'
import flatpickr from 'flatpickr'

// Connects to data-controller="flatpickr"
export default class extends Controller {
  static targets = ['input', 'hiddenInput']
  static values = {
    format: { type: String, default: 'Y-m-d' },
  }

  connect() {
    this.initializePicker()
  }

  disconnect() {
    if (this.picker) {
      this.picker.destroy()
    }
  }

  initializePicker() {
    // Get the initial date value from hidden input (ISO format)
    const initialDate = this.hasHiddenInputTarget
      ? this.hiddenInputTarget.value
      : null

    this.picker = flatpickr(this.inputTarget, {
      dateFormat: this.formatValue,
      altInput: false,
      defaultDate: initialDate,
      onChange: (selectedDates) => {
        if (selectedDates[0]) {
          // Update hidden field with ISO format for Rails submission
          const isoDate = selectedDates[0].toISOString().split('T')[0]

          if (this.hasHiddenInputTarget) {
            this.hiddenInputTarget.value = isoDate
            // Auto-submit the form
            this.hiddenInputTarget.form.requestSubmit()
          }
        }
      },
    })
  }
}
